import './Preventive.scss';

import PreventiveHeader from "./components/PreventiveHeader/PreventiveHeader";
import PreventiveContent from "./components/PreventiveContent/PreventiveContent";

const Preventive = () => {

    return (
        <div className={"preventive"}>
            <div className={"preventive_container"}>
                <div className={"preventive_header"}>
                    <PreventiveHeader/>
                </div>
                <div className={"preventive_content"}>
                    <PreventiveContent/>
                </div>
            </div>
        </div>
    )
}

export default Preventive;